export const IMA = 'IMA';
export const DISPLAY = 'DISPLAY';
export const VPAID = 'VPAID';
export const VAST = 'VAST';
